import { useEffect, useMemo, useState } from "react";
import { useRouteLoaderData } from "@remix-run/react";
import {
  useProductBase,
  useRelatedProducts,
} from "@made-people/grease-product";
import { mmRootLoader } from "../../../root-loader/mm-root-loader";
import { useGeneralSettings } from "../../../hooks/use-general-settings";
import { parseComfortSuiteSettings } from "../settings";
import { countCustomisationFeatures } from "../helpers";
import { CustomisationBanner } from "./customisation-banner";
import { CustomisationDrawer } from "./customisation-drawer";

export const CustomisationDrawerBox = () => {
  const rootLoaderData = useRouteLoaderData<typeof mmRootLoader>("root");
  const hasServerPayload = Boolean(rootLoaderData?.gbState?.p);
  const [mounted, setMounted] = useState(false);
  const productBase = useProductBase();
  const relatedProducts = useRelatedProducts();
  const generalSettings = useGeneralSettings();
  const { customisationFeatures, stylePickerGroups } = useMemo(
    () => parseComfortSuiteSettings(generalSettings),
    [generalSettings],
  );
  const customisationActive = useMemo(() => {
    if (!stylePickerGroups.length) {
      return false;
    }
    return stylePickerGroups.some((group) => {
      if (!group.categoryPage) {
        return false;
      }
      return productBase.categories.some(
        (category) => category.slug === group.categoryPage,
      );
    });
  }, [productBase.categories, stylePickerGroups]);

  const productIsCustomizable = useMemo(
    () => countCustomisationFeatures(relatedProducts) >= 2,
    [relatedProducts],
  );

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!hasServerPayload && !mounted) {
    return null;
  }

  if (!customisationActive) {
    return null;
  }

  if (!productIsCustomizable) {
    return null;
  }

  if (!customisationFeatures.length) {
    return null;
  }

  return (
    <>
      <CustomisationBanner />
      <CustomisationDrawer />
    </>
  );
};
